/* FENGE-structure behaviours for Horizon. Scoped to .ref-* only. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Hero slideshow: opacity cross-fade ---- */
  function initHero(root) {
    if (root.dataset.refInit === '1') return;
    root.dataset.refInit = '1';
    var slides = Array.prototype.slice.call(root.querySelectorAll('.ref-hero__slide'));
    if (slides.length < 2) return;
    var i = 0, timer = null;
    var delay = parseInt(root.dataset.autoplay || '0', 10) * 1000;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, x) { s.classList.toggle('is-active', x === i); });
    }
    function next() { show(i + 1); }
    function prev() { show(i - 1); }
    var nb = root.querySelector('[data-ref-hero-next]');
    var pb = root.querySelector('[data-ref-hero-prev]');
    if (nb) nb.addEventListener('click', function () { next(); restart(); });
    if (pb) pb.addEventListener('click', function () { prev(); restart(); });
    function restart() {
      if (timer) clearInterval(timer);
      if (delay > 0 && !reduce) timer = setInterval(next, delay);
    }
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { next(); restart(); }
      if (e.key === 'ArrowLeft') { prev(); restart(); }
    });
    show(0);
    restart();
  }

  /* ---- Horizontal rails: arrow paging + disabled states ---- */
  function initRail(wrap) {
    if (wrap.dataset.refInit === '1') return;
    wrap.dataset.refInit = '1';
    var rail = wrap.querySelector('.ref-rail');
    if (!rail) return;
    var prev = wrap.querySelector('.ref-nav--prev');
    var next = wrap.querySelector('.ref-nav--next');
    function step() {
      var first = rail.firstElementChild;
      if (!first) return rail.clientWidth;
      var gap = parseFloat(getComputedStyle(rail).columnGap || '16') || 16;
      return first.getBoundingClientRect().width + gap;
    }
    function sync() {
      var max = rail.scrollWidth - rail.clientWidth - 1;
      if (prev) prev.disabled = rail.scrollLeft <= 1;
      if (next) next.disabled = rail.scrollLeft >= max;
    }
    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
    window.addEventListener('load', sync);
    if (window.ResizeObserver) new ResizeObserver(sync).observe(rail);
  }

  /* ---- Video wall: viewport-driven playback + lightbox ---- */
  function initWall(root) {
    if (root.dataset.refInit === '1') return;
    root.dataset.refInit = '1';
    var cards = Array.prototype.slice.call(root.querySelectorAll('.ref-wall__card'));
    if (!cards.length) return;

    if ('IntersectionObserver' in window && !reduce) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target.querySelector('video');
          if (!v) return;
          if (en.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          else { v.pause(); }
        });
      }, { threshold: 0.35 });
      cards.forEach(function (c) { io.observe(c); });
    }

    var lb = root.querySelector('.ref-lb');
    if (!lb) return;
    var stage = lb.querySelector('.ref-lb__media');
    var counter = lb.querySelector('.ref-lb__counter');
    var idx = 0;

    function render() {
      var card = cards[idx];
      stage.innerHTML = '';
      var src = card.dataset.videoSrc;
      var img = card.dataset.imageSrc;
      var node;
      if (src) {
        node = document.createElement('video');
        node.src = src;
        node.controls = true;
        node.autoplay = true;
        node.playsInline = true;
        if (card.dataset.poster) node.poster = card.dataset.poster;
      } else if (img) {
        node = document.createElement('img');
        node.src = img;
        node.alt = card.dataset.label || '';
      }
      if (node) stage.appendChild(node);
      if (counter) counter.textContent = (idx + 1) + ' / ' + cards.length;
    }
    function open(n) {
      idx = n;
      render();
      lb.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      lb.classList.remove('is-open');
      stage.innerHTML = '';
      document.body.style.overflow = '';
    }
    cards.forEach(function (c, n) { c.addEventListener('click', function () { open(n); }); });
    var cl = lb.querySelector('.ref-lb__close');
    if (cl) cl.addEventListener('click', close);
    var pv = lb.querySelector('.ref-lb__nav--prev');
    var nx = lb.querySelector('.ref-lb__nav--next');
    if (pv) pv.addEventListener('click', function () { idx = (idx - 1 + cards.length) % cards.length; render(); });
    if (nx) nx.addEventListener('click', function () { idx = (idx + 1) % cards.length; render(); });
    lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowRight' && nx) nx.click();
      if (e.key === 'ArrowLeft' && pv) pv.click();
    });
  }

  function boot(scope) {
    var s = scope || document;
    s.querySelectorAll('.ref-hero').forEach(initHero);
    s.querySelectorAll('.ref-rail-wrap').forEach(initRail);
    s.querySelectorAll('.ref-wall').forEach(initWall);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  /* Theme editor re-render hooks */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:select', function (e) { boot(e.target); });
})();
